import axiosInstance from "../axios.config";
import { getUserToken } from "../utils/user.utils";

export const validateToken = async () => {
    try {
        const token = getUserToken()
        if (!token) return false // user doesnt have token no need for check 
        const response = await axiosInstance.post(
            `/Account/validateToken`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.status === 200;
    } catch (error) {
        return false;
    }
};

export const processLogin = async (email, password) => {
    return axiosInstance.post(`/Account/login`, { email, password })
}